import { Directive, HostListener, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appAllowOnlyDigits]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: OnlyDigitsDirective,
      multi: true,
    },
  ],
})
export class OnlyDigitsDirective implements Validator {
  @Input('maxDigits') maxDigits: number | null = null;
  @Input('minDigits') minDigits: number | null = null;

  constructor() {}
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.toString();

    if (!value?.length || this.minDigits === null) return null;

    if (value.length < this.minDigits) {
      return { minCharactersError: true };
    }

    return null;
  }

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Allow only numbers, strip non-numeric characters
    value = value.replace(/\D/g, '');

    // If the length exceeds maxDigits, truncate it
    if (this.maxDigits !== null && value.length > this.maxDigits) {
      value = value.substring(0, this.maxDigits);
    }

    // Update the input value
    input.value = value;
  }

  registerOnValidatorChange?(fn: () => void): void {}
}
